export class UpdatePanelSettingEntity {
  showCompletedOrderDurationInSecond?: number
  showCanceledOrderDurationInSecond?: number
  minimumPrizeCountForSpin?: number
  userPrizeExpirationTimeInDays?: number
  showOutOfStockItem?: boolean
  useCentralizedAutoDispatchFlow?: boolean
  userSpinWheelExpirationTimeInHours?: number
  defaultBranchDistanceCapInKm?: number | null
}
